import { WifiOff } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useOfflineDetection } from '@/hooks/useOfflineDetection';
import { cn } from '@/lib/utils';

interface OfflineIndicatorProps {
  className?: string;
  showAlert?: boolean;
}

export function OfflineIndicator({ className, showAlert = true }: OfflineIndicatorProps) {
  const { isOnline } = useOfflineDetection();
  const isOffline = !isOnline;

  if (!isOffline) return null;

  if (showAlert) {
    return (
      <Alert variant="destructive" className={cn("animate-fade-in", className)}>
        <WifiOff className="h-4 w-4" />
        <AlertDescription>
          You're currently offline. Some features may not be available.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className={cn(
      "flex items-center gap-2 rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive",
      className
    )}>
      <WifiOff className="h-4 w-4" />
      <span>Offline</span>
    </div>
  );
}